import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Text,
} from "@chakra-ui/react";
import { 
  MdPlayArrow as IcoLive,
  MdRssFeed as IcoNews,
  MdMic as IcoPodcasts,
  MdCategory as IcoPodcastsGroups,
  MdSettings as IcoSettings,
  MdPeople as IcoUsers,
  MdLogout as IcoLogout,
  MdNotificationsActive as IcoPushNotifications,
} from 'react-icons/md';
import "./menu.css";
import LogoRadioPalamos from "../../../assets/logos/imgLogoRadioPalamos.png";
// Actions
import * as authActions from "../../../redux/actions/auth";
import * as mainActions from "../../../redux/actions/main";

const MainMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const chatCenterRef = useRef(null);
  // States
  const [initializeRef, setInitializeRef] = useState(false);
  // Selectors
  const currentPage = useSelector(state => state.mainReducer.currentPage);
  const breadscrum = useSelector(state => state.mainReducer.breadscrum);
  const user = useSelector(state => state.authReducer.user);

  /*
  * Resize control
  */

  useEffect(() => {
    if (!chatCenterRef) return;
    const w = chatCenterRef.current.clientWidth;
    // console.log('w1', w);
    dispatch(mainActions.setMenuWidth(w));
    setInitializeRef(true);
  }, [chatCenterRef]); 

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [initializeRef]);

  const onResize = (e) => {
    // console.log("onResize", e);
    const w = chatCenterRef.current.clientWidth;
    // console.log('w2', w);
    dispatch(mainActions.setMenuWidth(w));
  };

  const renderMenuItem = (
    label, 
    IcoJsx, 
    isActivated, 
    onClick,
  ) => {
    let itemClass = "main-menu-item";
    if (isActivated) {
      itemClass += " main-menu-item-activated";
    }
    return (
      <Box 
        className={itemClass}
        onClick={onClick}
      >
        <IcoJsx size={24} />
        <Text ml="10px">
            {label}
        </Text>          
      </Box>
    );
  };

  const getGotoPath = (mainPage) => {
    let goTo = mainPage;
    const breadscrumPieces = !!breadscrum[goTo] ? breadscrum[goTo] : [];
    if (breadscrumPieces.length > 0) {
      const lastPiece = breadscrumPieces[breadscrumPieces.length - 1];
      goTo = lastPiece.path;       
    }
    // console.log('getGotoPath', goTo);
    return goTo;
  };

  return (
    <div id="main-menu" ref={chatCenterRef}>
      <img
        src={LogoRadioPalamos}
        id="main-menu-logo"
        alt="RÀDIO PALAMÓS"
      /> 
      <div className="main-menu-delimiter"></div>
      <div id="main-menu-main-wrapper">
        <div className="main-menu-items">
          {!!user && user.grants.news && 
            renderMenuItem("Noticies", IcoNews, currentPage === "news", () => {
              const page = "news";
              // Set active page
              dispatch(mainActions.setCurrentPage(page)).then(() => {
                // Goto
                navigate(`/${getGotoPath(page)}`);  
              });
            }
          )}
          {!!user && user.grants.podcasts_groups && 
            renderMenuItem("Grups de Podcasts", IcoPodcastsGroups, currentPage === "podcasts_groups", () => {
              const page = "podcasts_groups";
              // Set active page
              dispatch(mainActions.setCurrentPage(page)).then(() => {
                // Goto
                navigate(`/${getGotoPath(page)}`);  
              });
            }
          )}
          {!!user && user.grants.podcasts && 
            renderMenuItem("Podcasts", IcoPodcasts, currentPage === "podcasts", () => {
              const page = "podcasts";
              // Set active page
              dispatch(mainActions.setCurrentPage(page)).then(() => {
                // Goto
                navigate(`/${getGotoPath(page)}`);  
              });
            }
          )}
          {!!user && user.grants.live && 
            renderMenuItem("Directe", IcoLive, currentPage === "live", () => {
              const page = "live";
              // Set active page
              dispatch(mainActions.setCurrentPage(page)).then(() => {
                // Goto
                navigate(`/${getGotoPath(page)}`);  
              });
            },
          )}
          {!!user && user.grants.push_notifications && 
            renderMenuItem("Notificacions push", IcoPushNotifications, currentPage === "push_notifications", () => {
              const page = "push_notifications";
              // Set active page
              dispatch(mainActions.setCurrentPage(page)).then(() => {
                // Goto
                navigate(`/${getGotoPath(page)}`);  
              });
            }
          )}
        </div>
        {!!user && (
          user.grants.users || 
          user.grants.params
        ) &&
          <div className="main-menu-delimiter"></div>
        }
        <div className="main-menu-items">         
          {!!user && user.grants.users && 
            renderMenuItem("Usuaris", IcoUsers, currentPage === "users", () => {
              const page = "users";
              // Set active page
              dispatch(mainActions.setCurrentPage(page)).then(() => {
                // Goto
                navigate(`/${getGotoPath(page)}`);  
              });
            }
          )}          
          {!!user && user.grants.params && 
            renderMenuItem("Configuració", IcoSettings, currentPage === "settings", () => {
              const page = "settings";
              // Set active page
              dispatch(mainActions.setCurrentPage(page)).then(() => {
                if (!breadscrum[page]) {
                  const path = "settings_params";
                  dispatch(mainActions.setBreadscrum(page, [{ path, pathKey: path, primaryValue: "", primaryName: "", }]));                    
                }                
                // Goto
                navigate(`/${getGotoPath(page)}`);  
              });              
            }
          )}
        </div>
      </div>
      <div className="main-menu-delimiter"></div>
      <div id="main-menu-logout-wrapper">
        <div className="main-menu-items">
          {renderMenuItem("Sortir", IcoLogout, false, () => {
            // Logout
            dispatch(authActions.logout());
          })}       
        </div>
      </div>
    </div>
  );
};

export default MainMenu;
